import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import MyAccountQuery from 'Query/MyAccount.query';
import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    MyAccountInformationContainer as SourceMyAccountInformationContainer
} from 'SourceComponent/MyAccountInformation/MyAccountInformation.container';
import { CUSTOMER } from 'Store/MyAccount/MyAccount.dispatcher';
import { isSignedIn } from 'Util/Auth';
import BrowserDatabase from 'Util/BrowserDatabase';
import { fetchMutation } from 'Util/Request';
import { ONE_MONTH_IN_SECONDS } from 'Util/Request/QueryDispatcher';

import MyAccountDocuments from './MyAccountDocuments.component';

/** @namespace PeggysagePwa/Component/MyAccountDocuments/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state)
});

/** @namespace PeggysagePwa/Component/MyAccountDocuments/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch)
});

/** @namespace PeggysagePwa/Component/MyAccountDocuments/Container */
export class MyAccountDocumentsContainer extends SourceMyAccountInformationContainer {
    state = {
        ...this.state,
        files: {}
    };

    containerFunctions = {
        ...this.containerFunctions,
        onChangeFile: this.onChangeFile.bind(this)
    };

    onChangeFile(_e, { file }) {
        const { files } = this.state;

        const mergedFiles = { ...files, ...file };

        // Remove empty files (to not override customer data if fields are empty)
        const validFilesKeys = Object.keys(mergedFiles).filter((key) => !!mergedFiles[key]);
        const newFiles = validFilesKeys.reduce((acc, key) => {
            acc[key] = mergedFiles[key];

            return acc;
        }, {});

        this.setState({ files: newFiles });
    }

    /**
     * Override: format options for getUpdateInformationMutation() since the parameters had changed
     * @param options
     * @returns {Promise<void>}
     */
    async handleInformationChange(options) {
        const {
            updateCustomer
        } = this.props;

        const mutation = MyAccountQuery.getUpdateInformationMutation({ input: options });

        const { updateCustomerV2: { customer } } = await fetchMutation(mutation);

        BrowserDatabase.setItem(customer, CUSTOMER, ONE_MONTH_IN_SECONDS);
        updateCustomer(customer);
    }

    /**
     * Override: add documents on save
     * @param fields
     * @returns {Promise<void>}
     */
    async onCustomerSave(_fields) {
        const { updateCustomerLoadingStatus } = this.props;
        const { files } = this.state;

        if (!isSignedIn()) {
            return;
        }

        updateCustomerLoadingStatus(true);
        try {
            const options = {
                ...files
            };

            await this.handleInformationChange(options);

            this.handleSuccessChange();
        } catch (e) {
            this.handleLockAccount(e);
        }
    }

    render() {
        return (
            <MyAccountDocuments
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyAccountDocumentsContainer));
